// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import i18n from 'i18n-js';

import styles from './changeStopCardTitle.css';
import User from '../../User/index';

type ChangeStopCardTitleContentPropTypes = {
  studentPicture?: string,
  fromStop: string,
  toStop: string,
  studentFirstName?: string,
  studentLastName?: string,
};

const ChangeStopCardTitle = ({
  studentPicture,
  fromStop,
  toStop,
  studentFirstName = '',
  studentLastName = '',
}: ChangeStopCardTitleContentPropTypes) => (

  <div className={styles.changeStopTitle}>
    <User
      className={styles.userChangeStopCard}
      firstName={studentFirstName}
      lastName={studentLastName}
      pictureURL={studentPicture}
      theme="changeStop"
      size="extraSmall"
    />
    <div className={styles.stops}>
      <span>
        {`${i18n.t('changeStopRequests.from')} `}
          <strong className={styles.stopText}>{fromStop}</strong>
        {` ${i18n.t('changeStopRequests.to.one')} `}
          <strong className={styles.stopText}>{toStop}</strong>
      </span>
    </div>
  </div>
);


export default ChangeStopCardTitle;



// WEBPACK FOOTER //
// ./src/scripts/components/ChangeStopRequestCard/ChangeStopCardTitle/index.jsx